// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileImportResponse
 */
export interface IFileImportResponse {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof IFileImportResponse
     */
    parse_errors?: { [key: string]: { [key: string]: string; }; };
    /**
     * 
     * @type {string}
     * @memberof IFileImportResponse
     */
    info?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileImportResponse
     */
    file_error?: string;
    /**
     * 
     * @type {number}
     * @memberof IFileImportResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileImportResponse
     */
    file_type?: IFileImportResponseFileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFileImportResponse
     */
    file_processing_status_type?: IFileImportResponseFileProcessingStatusTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IFileImportResponse
     */
    processed_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IFileImportResponseFileTypeEnum {
    CENSUS = 'CENSUS',
    ENROLLMENT = 'ENROLLMENT',
    CONTRIBUTION = 'CONTRIBUTION',
    MD = 'MD',
    ED = 'ED',
    BAI2 = 'BAI2',
    BR = 'BR',
    MIXED = 'MIXED',
    CIP = 'CIP',
    ISO_302 = 'ISO_302',
    UNKNOWN = 'UNKNOWN',
    PGP_BAI2 = 'PGP_BAI2',
    CARRIER = 'CARRIER',
    ACH = 'ACH',
    CHECK_PAID = 'CHECK_PAID',
    CHECK_CANCELLED = 'CHECK_CANCELLED',
    DEPENDENT = 'DEPENDENT',
    BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT'
}
/**
* @export
* @enum {string}
*/
export enum IFileImportResponseFileProcessingStatusTypeEnum {
    INITIATED = 'INITIATED',
    UPLOADED = 'UPLOADED',
    PARSED = 'PARSED',
    VALIDATED = 'VALIDATED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    QUALITY_GATES_FAILED = 'QUALITY_GATES_FAILED',
    ERROR = 'ERROR',
    DUPLICATE = 'DUPLICATE',
    CANCELLED = 'CANCELLED'
}


/**
 * Check if a given object implements the IFileImportResponse interface.
 */
export function instanceOfIFileImportResponse(value: object): value is IFileImportResponse {
    return true;
}

export function IFileImportResponseFromJSON(json: any): IFileImportResponse {
    return IFileImportResponseFromJSONTyped(json, false);
}

export function IFileImportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileImportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'parse_errors': json['parse_errors'] == null ? undefined : json['parse_errors'],
        'info': json['info'] == null ? undefined : json['info'],
        'file_error': json['file_error'] == null ? undefined : json['file_error'],
        'id': json['id'] == null ? undefined : json['id'],
        'file_type': json['file_type'] == null ? undefined : json['file_type'],
        'file_processing_status_type': json['file_processing_status_type'] == null ? undefined : json['file_processing_status_type'],
        'processed_at': json['processed_at'] == null ? undefined : (new Date(json['processed_at'])),
    };
}

export function IFileImportResponseToJSON(json: any): IFileImportResponse {
    return IFileImportResponseToJSONTyped(json, false);
}

export function IFileImportResponseToJSONTyped(value?: IFileImportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parse_errors': value['parse_errors'],
        'info': value['info'],
        'file_error': value['file_error'],
        'id': value['id'],
        'file_type': value['file_type'],
        'file_processing_status_type': value['file_processing_status_type'],
        'processed_at': value['processed_at'] == null ? undefined : ((value['processed_at']).toISOString()),
    };
}

